export const phoneLength = {
  "AF": 9,
  "AL": 9,
  "DZ": 9,
  "AS": 10,
  "AD": 6,
  "AO": 9,
  "AI": 10,
  "AG": 10,
  "AR": 10,
  "AM": 8,
  "AW": 7,
  "AU": 9,
  "AT": 10,
  "AZ": 9,
  "BS": 10,
  "BH": 8,
  "BD": 10,
  "BB": 10,
  "BY": 9,
  "BE": 9,
  "BZ": 7,
  "BJ": 8,
  "BM": 10,
  "BT": 8,
  "BO": 8,
  "BA": 8,
  "BW": 8,
  "BR": 11,
  "BN": 7,
  "BG": 9,
  "BF": 8,
  "BI": 8,
  "KH": 9,
  "CM": 9,
  "CA": 10,
  "CV": 7,
  "KY": 10,
  "CF": 8,
  "TD": 8,
  "CL": 9,
  "CN": 11,
  "CO": 10,
  "KM": 7,
  "CG": 9,
  "CD": 9,
  "CR": 8,
  "CI": 8,
  "HR": 9,
  "CU": 8,
  "CY": 8,
  "CZ": 9,
  "DK": 8,
  "DJ": 8,
  "DM": 10,
  "DO": 10,
  "EC": 9,
  "EG": 10,
  "SV": 8,
  "GQ": 9,
  "ER": 7,
  "EE": 7,
  "SZ": 8,
  "ET": 9,
  "FI": 10,
  "FR": 9,
  "GF": 9,
  "GA": 8,
  "GM": 7,
  "GE": 9,
  "DE": 11,
  "GH": 9,
  "GI": 8,
  "GR": 10,
  "GL": 6,
  "GD": 10,
  "GP": 9,
  "GU": 10,
  "GT": 8,
  "GN": 9,
  "GW": 7,
  "GY": 7,
  "HT": 8,
  "HN": 8,
  "HK": 8,
  "HU": 9,
  "IS": 7,
  "IN": 10,
  "ID": 10,
  "IR": 10,
  "IQ": 10,
  "IE": 9,
  "IL": 9,
  "IT": 10,
  "JM": 10,
  "JP": 10,
  "JO": 9,
  "KZ": 10,
  "KE": 9,
  "KI": 5,
  "KR": 10,
  "KW": 8,
  "KG": 9,
  "LA": 10,
  "LV": 8,
  "LB": 8,
  "LS": 8,
  "LR": 8,
  "LY": 9,
  "LI": 7,
  "LT": 8,
  "LU": 9,
  "MO": 8,
  "MK": 8,
  "MG": 9,
  "MW": 9,
  "MY": 9,
  "MV": 7,
  "ML": 8,
  "MT": 8,
  "MQ": 9,
  "MR": 8,
  "MU": 8,
  "MX": 10,
  "MD": 8,
  "MC": 8,
  "MN": 8,
  "ME": 8,
  "MS": 10,
  "MA": 9,
  "MZ": 9,
  "MM": 9,
  "NA": 9,
  "NP": 10,
  "NL": 9,
  "NZ": 9,
  "NI": 8,
  "NE": 8,
  "NG": 10,
  "NO": 8,
  "OM": 8,
  "PK": 10,
  "PS": 9,
  "PA": 8,
  "PG": 7,
  "PY": 9,
  "PE": 9,
  "PH": 10,
  "PL": 9,
  "PT": 9,
  "PR": 10,
  "QA": 8,
  "RO": 9,
  "RU": 10,
  "RW": 9,
  "SA": 9,
  "SN": 9,
  "RS": 9,
  "SC": 7,
  "SL": 8,
  "SG": 8,
  "SK": 9,
  "SI": 8,
  "SB": 7,
  "SO": 9,
  "ZA": 9,
  "SS": 9,
  "ES": 9,
  "LK": 9,
  "SD": 9,
  "SR": 7,
  "SE": 9,
  "CH": 9,
  "SY": 9,
  "TW": 10,
  "TJ": 9,
  "TZ": 9,
  "TH": 9,
  "TG": 8,
  "TT": 10,
  "TN": 8,
  "TR": 10,
  "TM": 8,
  "UG": 9,
  "UA": 9,
  "AE": 9,
  "GB": 10,
  "US": 10,
  "UY": 8,
  "UZ": 9,
  "VE": 10,
  "VN": 10,
  "YE": 9,
  "ZM": 9,
  "ZW": 9,
}